import { render, staticRenderFns } from "./form-billing.vue?vue&type=template&id=c2d73694&scoped=true&"
import script from "./form-billing.vue?vue&type=script&lang=js&"
export * from "./form-billing.vue?vue&type=script&lang=js&"
import style0 from "./form-billing.vue?vue&type=style&index=0&id=c2d73694&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d73694",
  null
  
)

export default component.exports